// extracted by mini-css-extract-plugin
module.exports = {"button":"HeaderButtonNotifications_button__N9srM","icon":"HeaderButtonNotifications_icon__oEgPg"};